import { UIRouter, Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { HomeComponent } from './home.component';
import { resolveStateParams } from '../global/resolves/params.resolve';

export let STATES: Ng2StateDeclaration[] = [
  {
    name: 'main.home',
    url: '/?code',
    views: {
      '$default@': {component: HomeComponent}
    },
    resolve: [
      resolveStateParams
    ],
    params: {
      header: {
        hideBackButton: true,
        hidePlayButton: false
      },
      test: null,
      auth: {
        redirect: false,
        returnTo: null
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/home/home.states.ts